import React, { Component } from 'react';
import moment from 'moment';

import { getUrlParam } from '@themejs/helpers/url';
import API from '@api';
import config from '@config';
import { getAppDownloadLink } from '@helpers';

const locationHost = window.location.host;
let isFreely = false;

if (locationHost.indexOf('freely') > -1) {
  isFreely = true;
}

class DetailPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      program: null,
      channel: null,
    };
  }

  componentDidMount() {
    const urlPid = getUrlParam('pid');
    if (urlPid) {
      API.getProgramDetailsSimple(urlPid)
        .then(data => {
          if (data && data.main_title) {
            API.getMobileOwningServices().then(msdata => {
              const targetService = msdata.find(
                s => s.service_id === data.service_id,
              );

              this.setState({
                program: data,
                channel: targetService,
              });
              this.props.bypassOpening();
            });
          } else {
            this.props.bypassOpening();
          }
        })
        .catch(err => {
          this.props.bypassOpening();
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.program &&
      this.props.program.uuid &&
      !this.props.program.requesting &&
      this.props.program.program_id &&
      this.props.program.more_episodes_ondemand &&
      (!this.props.program.related || this.props.program.related.length == 0)
    ) {
      this.props.getMoreEpisodes(
        this.props.channel.service_id,
        this.props.nid,
        this.props.program.uuid,
        this.props.program.program_id,
      );
    }

    if (
      this.props.display !== prevProps.display &&
      this.props.display &&
      window.innerWidth <= config.breakpoints.mobile
    ) {
      const event = new Event('scroll-disabled');
      document.body.classList.add('no-scroll');
      window.dispatchEvent(event);
    } else {
    }

    if (this.props.display !== prevProps.display && !this.props.display) {
      document.body.classList.remove('no-scroll');
      const event = new Event('scroll-enabled');
      window.dispatchEvent(event);
    }
  }

  render() {
    let program = false;
    let channel;

    const { display, bypass, relatedPrograms } = this.props;

    program = this.props.program;
    channel = this.props.channel;

    if (bypass) {
      program = this.state.program;
      channel = this.state.channel;
    }

    return (
      <section
        className={`fv-detail-panel ${
          display || bypass ? 'fv-detail-panel--active' : ''
        }`}
      >
        {program && (
          <div className="fv-detail-panel__content">
            <span className="icon-close" onClick={this.props.closePanel} />
            {channel && (
              <img
                className="fv-detail-panel__channel"
                src={`${channel.service_image}?w=${config.channelImageWidth}`}
                alt=""
                loading="lazy"
              />
            )}

            <div
              className="fv-detail-panel__header"
              style={
                program.image_url
                  ? {
                      backgroundImage: `url(${program.image_url}?w=${config.detailPanelImageWidth})`,
                    }
                  : {}
              }
            >
              <div className="fv-detail-panel__header__inner">
                <div className="fv-detail-panel__header__content">
                  <p className="fv-detail-panel__header__secondary-title">
                    {program.secondary_title}
                  </p>
                  <h3
                    dangerouslySetInnerHTML={{ __html: program.main_title }}
                    data-program-link={`${location.origin}/tv-guide?pid=${program.program_id}`}
                  />
                  {program.start_time && (
                    <p className="fv-detail-panel__header__time-infos">
                      {moment(program.start_time).format('DD MMM YYYY - h:mma')}{' '}
                      -{' '}
                      {moment(program.start_time)
                        .add(moment.duration(program.duration))
                        .format('h:mma')}
                    </p>
                  )}
                  <div className="fv-detail-panel__header__links">
                    {program.player_links &&
                      program.player_links.tv &&
                      program.player_links.tv.program_url && (
                        <a
                          href={program.player_links.tv.program_url}
                          target="_blank"
                          className="watch-now"
                        >
                          {isFreely ? (
                            <img
                              src="/themes/custom/freely/img/play_btn.svg"
                              alt=""
                            />
                          ) : (
                            <img
                              src="/themes/custom/freeview/img/play_btn.svg"
                              alt=""
                            />
                          )}
                          <span>
                            <b>Watch now</b>
                          </span>
                        </a>
                      )}
                    {isFreely ? (
                      ''
                    ) : (
                      <a href={getAppDownloadLink()}>
                        <img
                          src="/themes/custom/freeview/img/fw_phone.svg"
                          alt=""
                        />
                        <span>
                          <b>Download our</b> Freeview mobile app
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="fv-detail-panel__block fv-detail-panel__summary">
              <h5>Summary</h5>
              <p>
                {program.synopsis &&
                  (program.synopsis.long ||
                    program.synopsis.medium ||
                    program.synopsis.short)}
              </p>
              {drupalSettings.tvguide_settings &&
              drupalSettings.tvguide_settings.link ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: drupalSettings.tvguide_settings.link,
                  }}
                />
              ) : (
                ''
              )}
            </div>
            <div className="fv-detail-panel__ads">
              <h5>{drupalSettings.tvguide_sidebar_advertisement.title}</h5>
              <div
                dangerouslySetInnerHTML={{
                  __html: drupalSettings.tvguide_sidebar_advertisement.text,
                }}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: drupalSettings.tvguide_sidebar_advertisement.link,
                }}
              />
            </div>
            {relatedPrograms && relatedPrograms.length > 0 && (
              <div className="fv-detail-panel__block fv-detail-panel__suggestions">
                <h5>More</h5>
                <div className="fv-detail-panel__suggestions__inner">
                  {relatedPrograms.slice(0, 2).map(r => (
                    <div
                      key={`related-${r.uuid}`}
                      className="fv-detail-panel__suggestions__program"
                      onClick={(() => {
                        this.props.displayProgramDetails(
                          channel.service_id,
                          r.uuid,
                          r.program_id,
                        );
                      }).bind(this)}
                    >
                      <img
                        src={`${r.image_url}?w=${config.programCardImageWidth}`}
                        alt=""
                      />
                      <p>{r.secondary_title}</p>
                      <h6 dangerouslySetInnerHTML={{ __html: r.main_title }} />
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="fv-detail-panel__cast" />
          </div>
        )}
        {!program && (
          <div className="fv-detail-panel__content fv-detail-panel__content--not-available">
            <span className="icon-close" onClick={this.props.closePanel} />
            <div className="fv-detail-panel__block fv-detail-panel__not-available">
              <i className="icon-alert_lg" />
              <h3>The content you are looking for is no longer available.</h3>
              <p>
                The content may be out of date, please try using the TV guide or
                search to find what you are looking for. If you’re still
                struggling try searching our help section.
              </p>
              <a className="fv-link fv-link--chevron" href="/help">
                Go to Help section
              </a>
            </div>
          </div>
        )}
      </section>
    );
  }
}

export default DetailPanel;
